export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/ar-eg.lyaml"));
at({});
};